






import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Copyright',
})
export default class Copyright extends Vue {

}
